import { pageNames } from '@atc/bonnet-paths';
import dealerSearchPathCreator from './creators/dealerSearchPathCreator';

export default dealerSearchPathCreator({
    namespace: pageNames.DEALER_DETAILS,
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});
